export const emptyValue = '—'

export const negativeMarginSkusCaptions = {
  none: 'Todos los productos por encima de coste',
  some: 'con margen negativo',
}
